import { ApolloQueryResult } from 'apollo-client';

import { minusPhraseLibraryGridQuery, minusPhraseLibraryQuery } from '../../graphql/queries/grid/minus-phrase';
import { mapMinusPhraseRowApiData } from '../../mappers/minus-phrase/minus-phrase';
import { rumCounters } from '../../service/RUM/RUM';
import {
    GdCalcTypeInput,
    GdStatPresetInput,
    minusPhraseLibraryGridQuery as MinusPhraseLibraryGridQuery,
    minusPhraseLibraryQuery as MinusPhraseLibraryQuery
} from '../../typings/graphql-grid';
import { MinusPhraseLibraryRow } from '../../typings/minusPhraseLibrary';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export type FetchMinusPhraseLibraryDataResult = {
    data: Array<MinusPhraseLibraryRow>;
    totalCount: number;
    reqId: string;
};

export type FetchMinusPhraseLibraryGridDataResult = {
    data: Array<MinusPhraseLibraryRow>;
    campaignsIds: string[];
    totalCount: number;
    reqId: string;
};

export class MinusPhraseLibraryProvider extends BaseDataProvider {
    public fetchMinusPhraseLibraryGridData = (
        offset: number,
        count: number,
        login: string
    ): Promise<FetchMinusPhraseLibraryGridDataResult> => {
        return this.createQuery<MinusPhraseLibraryGridQuery>(minusPhraseLibraryGridQuery, {
            variables: {
                minusPhraseInput: {
                    limitOffset: {
                        offset,
                        limit: count
                    }
                },
                login,
                campaignInput: {
                    limitOffset: {
                        offset: 0,
                        limit: 10000
                    },
                    statRequirements: {
                        preset: GdStatPresetInput.TODAY
                    },
                    filter: {
                        calcType: GdCalcTypeInput.CPC
                    },
                    orderBy: []
                }
            }
        }).then(
            (result: ApolloQueryResult<MinusPhraseLibraryGridQuery>): FetchMinusPhraseLibraryGridDataResult => {
                return {
                    data: mapMinusPhraseRowApiData(result.data.getLibraryMinusKeywordsPacks.rowset),
                    totalCount: result.data.getLibraryMinusKeywordsPacks.totalCount,
                    reqId: result.data.reqId,
                    campaignsIds: result.data.client.campaigns.rowset.map(item => item.id)
                };
            }
        );
    };

    public fetchMinusPhraseLibraryData = (
        offset: number,
        count: number
    ): Promise<FetchMinusPhraseLibraryDataResult> => {
        return this.createQuery<MinusPhraseLibraryQuery>(
            minusPhraseLibraryQuery,
            {
                variables: {
                    input: {
                        limitOffset: {
                            offset,
                            limit: count
                        }
                    }
                }
            },
            rumCounters.backendMinusPhraseLibraryGrid
        ).then(
            (result: ApolloQueryResult<MinusPhraseLibraryQuery>): FetchMinusPhraseLibraryDataResult => {
                return {
                    data: mapMinusPhraseRowApiData(result.data.getLibraryMinusKeywordsPacks.rowset),
                    totalCount: result.data.getLibraryMinusKeywordsPacks.totalCount,
                    reqId: result.data.reqId
                };
            }
        );
    };
}
